import { InputAdornment, Grid2 as Grid, TextField } from "@mui/material";

type TextFieldProps = {
    label: string,
    value: string,
    setValue: (v: string) => void,
    helperText?: string,
    error?: string,
    disabled?: boolean,
    required?: boolean,
    multiline?: boolean,
    maxLength?: number,
    inputAdornment?: string,
    type?: string,
    size?: number
}

const FormTextField = ({
    label,
    value,
    setValue,
    helperText = "",
    error = "",
    disabled = false,
    required = false,
    multiline = false,
    maxLength = undefined,
    inputAdornment = "",
    type = "text",
    size = 6
}: TextFieldProps) => {
    const getHelperText = () => {
        if (error !== "") {
            return error;
        } else {
            return helperText;
        }
    }
    
    return (
        <Grid size={size}>
            <TextField 
                fullWidth
                label={label}
                error={error !== ""}
                helperText={getHelperText()}
                multiline={multiline}
                rows={multiline ? 4 : 1}
                value={value}
                type={type}
                disabled={disabled}
                required={required}
                onChange={(e) => { setValue(e.target.value) }}
                slotProps={{
                    input: {
                        startAdornment: inputAdornment !== "" ?
                            <InputAdornment position="start">{inputAdornment}</InputAdornment> : null,
                    },
                    htmlInput: {
                        maxLength: maxLength
                    }
                }}
            />
        </Grid>
    )
}

export default FormTextField;
